import React from 'react';
import Promise from 'bluebird';
import _ from 'lodash';

import component from '../component';
import LinkButton from '../LinkButton';
import TopBanner from '../TopBanner';
import TopHeader from '../TopHeader';
import {HBox, VBox} from '../Box';
import SubNav from '../SubNav';
import TournamentAnnouncement from '../TournamentAnnouncement';
import Games from '../Games';
import LoadMoreButton from '../LoadMoreButton';
import Api from '../../api';
import moment from 'moment';

const cntPromoted = 3;
const cntDiff = 4;
const cntInit = cntPromoted + cntDiff;

export default component('Tournaments', function({data, params, query}) {

  const path = ['tournaments'];

  let tournaments = data.getIn(path.concat('list'));

  if(query.type === 'in_progress' && tournaments){
    // there are loaded all not finished tournaments from different api methods.
    // this is a quick workaround to sort them all.
    tournaments = _.sortBy(tournaments.toJS(), (tournament)=>(parseInt(moment(tournament.dates.from).format('x'))));
    data.setIn(path.concat('list'), tournaments);
    tournaments = data.getIn(path.concat('list'));
  }

  // TODO incapsulate `shownCnt` into @paginated decorator?
  if (!data.getIn(path.concat('shownCnt'))) {
    data.setIn(path.concat('shownCnt'), cntInit);
  }

  const subNav = data.getIn(['nav'])
      .find(x => x.get('name') === 'tournaments')
      .get('children');

  async function loadMore() {
    if (!data.getIn(path.concat('noMore'))) {
      data.setIn(path.concat('loading'), true);
      await Api.tournaments(data, params, query);
      data.setIn(path.concat('loading'), false);
    }
    data.setIn(path.concat('shownCnt'), data.getIn(path.concat('shownCnt')) + cntDiff);
  }

  let visibleChunks = [];



  if (tournaments) {
    const notPromotedTournaments = tournaments.slice(cntPromoted);
    visibleChunks = notPromotedTournaments.map((item, index) => {
      if (index % cntDiff === 0 && (index + cntDiff) < data.getIn(path.concat('shownCnt'))) {
        return notPromotedTournaments.slice(index, index + cntDiff)
      }
    }).filter(x => x);
  }

  return (
    <div>
      <TopBanner size='small'>
        <TopHeader>Турниры</TopHeader>
        <SubNav data={subNav} params={params} doNotHighlightParent />
      </TopBanner>
      <Games data={data.cursor('gamesRecent')} />
      {tournaments &&
        <HBox width={4}>
          <VBox width={2}>
            <TournamentAnnouncement picPosition='top' description={true} details data={tournaments.get(0)} />
          </VBox>
          <VBox width={2}>
            <HBox width={2}>
              <TournamentAnnouncement picPosition='left' description={false} details={false} data={tournaments.get(1)} />
            </HBox>
            <HBox width={2}>
              <TournamentAnnouncement picPosition='left' description={false} details={false} data={tournaments.get(2)} />
            </HBox>
          </VBox>
        </HBox>
      }
      {visibleChunks.map((row, i) => {
        return <HBox width={4} key={i}>
          <VBox>
            <TournamentAnnouncement picPosition='top' description details={false} data={row.get(0)} />
          </VBox>
          {!row.get(1) ? <VBox isContainer /> :
            <VBox>
              <TournamentAnnouncement picPosition='top' description details={false} data={row.get(1)} />
            </VBox>
          }
          {!row.get(2) ? <VBox isContainer /> :
            <VBox>
              <TournamentAnnouncement picPosition='top' description details={false} data={row.get(2)} />
            </VBox>
          }
          {!row.get(3) ? <VBox isContainer /> :
            <VBox>
              <TournamentAnnouncement picPosition='top' description details={false} data={row.get(3)} />
            </VBox>
          }
        </HBox>
      })}
      {(!data.getIn(path.concat('noMore')) || (tournaments.size > data.getIn(path.concat('shownCnt')))) &&
        <HBox width={4} isContainer={true}>
          <LoadMoreButton text='турниров' onClick={loadMore}
                          loading={data.getIn(path.concat('loading'))} />
        </HBox>
      }
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/pages/Tournaments.js